




























































import mixins from 'vue-typed-mixins';
import WorksheetUtils, {
  Worksheet,
  WorksheetHeader,
} from '@/utils/WorksheetUtils';
import { SurveyGroup } from '@/utils/SurveyUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => Worksheet['layout'],
    },
    surveygroup: {
      type: Object as () => SurveyGroup,
    },
  },

  computed: {
    questionsOptions(): any {
      return this.questions?.map((question) => ({
        text: question.key,
        value: question,
      }));
    },
  },

  data(): {
    questions?: WorksheetHeader['question'][];
  } {
    return {
      questions: undefined,
    };
  },

  async mounted() {
    try {
      this.questions = await WorksheetUtils.api.listQuestions({
        surveygroupid: this.surveygroup.id as number,
      });

      // merge the questions into the headers to have up to date values
      this.value.headers?.forEach((header) => {
        if (header.question) {
          header.question = this.questions?.find(
            (question) => question.key === header.question?.key
          );
        }
      });
    } catch (error) {
      this.$alert.show('mounted', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },

  methods: {
    create() {
      this.value.headers.push({
        name: this.$languageobj(),
        question: undefined,
      });
    },

    async remove(index: number) {
      await this.$confirm(
        this.$i18n.tc('validation.confirmation.delete', 1, [
          this.$translate(this.value.headers[index].name) ||
            this.$i18n.tc('model.worksheet.layout.header.label'),
        ]),
        async () => {
          this.value.headers.splice(index, 1);
        }
      );
    },
  },
});
